
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { LocalidadBasicDto } from '@models/localidad/localidadBasicDto.model';
import { ProvinciaDto } from '@models/provincia/provinciaDto.model';
import { BuscarProvinciaGeorefComponent } from '../buscar-provincia-georef/buscar-provincia-georef.component';
import { BuscarLocalidadGeorefComponent } from '../buscar-localidad-georef/buscar-localidad-georef.component';
import { BaseDto } from '@models/base/baseDto.model';
import { GeorefService } from '@services/georef/georef.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { startWith, debounceTime, map } from 'rxjs';

@Component({
  selector: 'app-selector-localidad-provincia',
  standalone: true,
  imports: [CommonModule, BuscarProvinciaGeorefComponent, BuscarLocalidadGeorefComponent, NgxSpinnerModule],
  templateUrl: './buscar-provincia-localidad-georef.component.html',
  styleUrl: './buscar-provincia-localidad-georef.component.css',
})
export class BuscarProvinciaLocalidadGeorefComponent implements OnInit {
  @Input() idLocalidadActual?: number; // Recibe una localidad preexistente si la hay.
  @Output() localidadSeleccionada = new EventEmitter<LocalidadBasicDto>();

  @Input() idLocalidadSeleccionadaInput?: number;

  provinciaActual?: any;
  provincia: BaseDto | null = null; // Aquí se guarda la provincia seleccionada.
  localidad: LocalidadBasicDto | null = null; // Aquí se guarda la localidad seleccionada.

  constructor(
    private georefService: GeorefService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    if (this.idLocalidadActual) {
      this.getProvincias()
    }
    if (this.idLocalidadSeleccionadaInput) {
      this.setearProvinciaYLocalidad(this.idLocalidadSeleccionadaInput);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.idLocalidadActual) {
      this.getProvincias()
    }
    if (this.idLocalidadSeleccionadaInput) {
      this.setearProvinciaYLocalidad(this.idLocalidadSeleccionadaInput);
    }
  }



  onProvinciaSeleccionada(provincia: ProvinciaDto) {
    this.provincia = provincia; // Se actualiza cuando el usuario selecciona una provincia.
    this.provinciaActual = provincia; // Se actualiza cuando el usuario selecciona una provincia.
    this.localidad = null; // Si se cambia la provincia, se resetea la localidad seleccionada.
  }

  onLocalidadSeleccionada(localidad: LocalidadBasicDto) {
    this.localidadSeleccionada.emit(localidad); // Se emite la localidad seleccionada al componente superior.
  }

  private setearProvinciaYLocalidad(idLocalidad: number): void {
    if (idLocalidad) {
      this.getLocalidadPorId(idLocalidad);
    }

  }

  getProvincias(): void {
    this.spinner.show('spProvinciaLocalidad');
    this.georefService.getProvincias().subscribe({
      next: (data) => {
        this.spinner.hide('spProvinciaLocalidad');
        if (data) {
          this.provinciaActual = data.provincia;
          this.provincia = data.provincia;
        }
      },
      error: (error) => {
        this.spinner.hide('spProvinciaLocalidad');
        this.snackBar.showError(error, 'Error');
      }
    });
  }



  getLocalidadPorId(idLocalidad: number): void {
    this.spinner.show('spProvinciaLocalidad');
    this.georefService.getLocalidadPorId(idLocalidad).subscribe({
      next: (data) => {
        this.spinner.hide('spProvinciaLocalidad');
        if (data) {
          this.idLocalidadActual = data.id;
          this.provinciaActual = data.provincia;
          this.provincia = data.provincia;
        }
      },
      error: (error) => {
        this.spinner.hide('spProvinciaLocalidad');
        this.snackBar.showError(error, 'Error');
      }
    });
  }


}
